<sirius-text-html-paragraph [textStyleSize]="textStyleSize()" [html]="textHtml"></sirius-text-html-paragraph>
<span class="arrow"></span>
